import { FindHint } from '../components/document-viewer/types';

export interface CustomFixtureField {
    id: string;
    label: string;
    value: string;
    detail?: string;
}

export interface CustomFixture {
    id: string;
    label: string;
    kind: 'image' | 'pdf';
    filename: string;
    src: string;
    expenseTypeName?: string;
    amount?: number;
    dateLabel?: string;
    fields: CustomFixtureField[];
}

export const CUSTOM_FIXTURES: CustomFixture[] = [];

export function getCustomFixtureById(id: string): CustomFixture | undefined {
    for (let i = 0; i < CUSTOM_FIXTURES.length; i++) {
        if (CUSTOM_FIXTURES[i].id === id) {
            return CUSTOM_FIXTURES[i];
        }
    }
    return undefined;
}

export function buildCustomFindHints(fixture: CustomFixture | null | undefined): FindHint[] {
    if (!fixture) {
        return [];
    }
    return fixture.fields
        .filter(f => !!(f.value || '').trim())
        .map(f => ({
            id: 'custom-' + fixture.id + '-' + f.id,
            label: f.label,
            value: f.value,
            detail: f.detail || f.value
        }));
}
